import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import ReactJson from 'react-json-view'
import {useAppDispatch} from 'redux/config'
import {
  Button,
  Icon,
  Spinner,
  Typography,
  Stack,
  ErrorState,
} from '@mdsol/onex-design'
import {
  select_jobCreateRequest,
  select_gridSession_show_JobCreateRequestForm,
  select_statusDetails,
  select_error,
  select_requestIdDetails,
} from 'redux/jobRequests/selectors'
import {Status} from 'commonTypes'
import 'components/common/grid/grid.scss'
import {jobRequestAC, fetchJobRequestDetails} from '../../../../redux/jobRequests/jobRequests.duck'
import JobRequest from 'components/view/jobRequests/JobRequestForm'

const JobRequestDetailsPanel: FC = () => {
  const dispatch = useAppDispatch()

  const jobCreateRequest = useSelector(select_jobCreateRequest)
  const status = useSelector(select_statusDetails)
  const showJobCreateRequestForm = useSelector(select_gridSession_show_JobCreateRequestForm)
  const error = useSelector(select_error)
  const requestIdDetails = useSelector(select_requestIdDetails)
  const handleClose = () => {
    dispatch(jobRequestAC.hideDetails())
    dispatch(jobRequestAC.clearForm())
  }

  const handleRefreshDetails = () => {
    dispatch(fetchJobRequestDetails(requestIdDetails))
  }

  return (
    <div className='row-details-panel' role='job-request-details-container'>
      <div className='header onex-data-grid-control'>

        <Typography variant='h4'>
          {showJobCreateRequestForm ? 'Job Request' : 'Job Request Details'}
        </Typography>
        <Button dataTestId='close-details-icon' onClick={handleClose} variant='secondary' buttonStyle='ghost' buttonType='icon'>
          <Icon>close</Icon>
        </Button>
      </div>
      {showJobCreateRequestForm
        ? <JobRequest />
        :
        <div className={`body onex-data-grid-control ${status === Status.PENDING ? 'with-spinner' : ''}`}>
          {status === Status.PENDING && <Spinner dataTestId='dataload-request-details-spinner' size='lg' />}
          {jobCreateRequest && status === Status.OK && (
            <ReactJson
              src={jobCreateRequest}
              theme='rjv-default'
              iconStyle='circle'
              indentWidth={2}
              collapseStringsAfterLength={16}
              quotesOnKeys={false}
            />
          )
          }
          {status === Status.REJECTED && (
            <ErrorState
              buttonTitle='Try again'
              className='error-state-component-details'
              dataTestId='details-error-state'
              description={error?.message ?? 'Error occurred while loading job request details.'}
              onClick={handleRefreshDetails}
              title='Server Error'
              defaultImgVariant='browser'
              variant='section'
              errorId={requestIdDetails}
            />)
          }
        </div>
      }
      <div className='footer onex-data-grid-control'>
        <Stack direction='horizontal' gap={2}>
          <Button dataTestId='close-details-button' onClick={handleClose} size='md' variant='secondary'>
            Close
          </Button>
        </Stack>
      </div>
    </div>
  )
}

export default JobRequestDetailsPanel
